const headers = {
  accept: 'application/json',
  'content-type': 'application/json'
}

export default {
  /**
   * https://wiki.teltonika-gps.com/view/FMB900_SMS/GPRS_Commands
   */
  sendCommand (request) {
    return fetch('/device/send-command', {
      method: 'POST',
      credentials: 'include',
      redirect: 'error',
      headers,
      body: JSON.stringify(request)
    }).then(response => response.json())
  },
  lockIgnition (request) {
    return fetch('/device/lock-ignition', {
      method: 'POST',
      credentials: 'include',
      redirect: 'error',
      headers,
      body: JSON.stringify(request)
    }).then(response => response.json())
  },
  unlockIgnition (request) {
    return fetch('/device/unlock-ignition', {
      method: 'POST',
      credentials: 'include',
      redirect: 'error',
      headers,
      body: JSON.stringify(request)
    }).then(response => response.json())
  },
  fastConfig (request) {
    return fetch('/device/fast-config', {
      method: 'POST',
      credentials: 'include',
      redirect: 'error',
      headers,
      body: JSON.stringify(request)
    }).then(response => response.json())
  }
}
